import _ from 'lodash'
import $ from 'jquery'

class Translator {
  constructor() {
    this.translations = {}
  }

  /**
   * Set the translations object from the data-translations attr in the html.
   */
  setTranslations() {
    const translations = $('.language-dropdown').data('translations')
    this.translations = translations === '*' ? {} : translations
  }

  /**
   * Get the translation line or fallback to the key.
   */
  getLine(key) {
    let line = _.get(this.translations, [key], key)
    if (line === "") {
      line = key
    }

    return line
  }

  /**
   * Get the translation for a string.
   */
  trans(key, replace = {}) {
    // console.log('Translating', key, replace)
    const line = this.getLine(key)
    // console.log('Line', line)
    const translation = this.makeReplacements(line, replace)
    // console.log('Translation', translation)

    return translation
  }

  /**
   * Get the translation according to an integer value
   */
  trans_choice(key, count = 1, replace = {}) {
    const lines = this.getLine(key).split('|')
    const line = count > 1 && (lines.length > 1) ? lines[1] : lines[0];
    const translation = this.makeReplacements(line, replace)

    return translation
  }

  /**
   * Make the place-holder replacements on a line.
   */
  makeReplacements(line, replace = {}) {
    // console.log('Replacing', line, replace)
    const replacements = this.sortReplacements(replace)
    for (let i = 0; i < replacements.length; i++) {
      const placeholder = replacements[i].placeholder
      const replacement = replacements[i].replacement
      line = line.replace(`:${placeholder}`, replacement)
        .replace(`:${placeholder.toUpperCase()}`, replacement.toUpperCase())
        .replace(`:${_.capitalize(placeholder)}`, _.capitalize(replacement))
    }

    return line
  }

  /**
   * Sort the replacements
   */
  sortReplacements(replace = {}) {
    const keys = Object.keys(replace)
    const replacements = []
    keys.sort((a, b) => {
      return this.getCharacterLength(b) - this.getCharacterLength(a)
    })
    for (let i = 0; i < keys.length; i++) {
      replacements.push({
        placeholder: keys[i],
        replacement: replace[keys[i]]
      })
    }

    // console.log('Ordered replacements', replacements)
    return replacements
  }

  /**
   * Count string characters
   */
  getCharacterLength(str) {
    // The string iterator that is used here iterates over characters,
    // not mere code units
    return [...str].length
  }

  /**
   * Get the translations map when the page is finished loading.
   */
  onLoad() {
    this.setTranslations()
  }

}

// class MessageSelector {
//
//   /**
//    * Get the translation string if the condition matches.
//    */
//   extractFromString(part, number) {
//     const regex = /^[\{\[]([^\[\]\{\}]*)[\}\]](.*)/
//     const matches = part.match(regex)
//
//     if (matches.length !== 3) {
//       return
//     }
//
//     const condition = matches[1]
//     const value = matches[2]
//
//     if (condition.indexOf(',') !== -1) {
//       const range = condition.split(',', 2)
//       if (range[1] === '*' && number >= range[0]) {
//         return value
//       }
//       else if (range[0] === '*' && number <= range[1]) {
//         return value
//       }
//       else if (number >= range[0] && number <= range[1]) {
//         return value
//       }
//     }
//
//     return condition == number ? value : null
//   }
// }

export { Translator }
